import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.wheel.loaded,
    (loaded) => {
        return {
            loaded
        }
    }
)